import {useMutation} from "@tanstack/react-query";
import {InvSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportInvExcel} from "../../../../../api/inventory/InvApi";

export const useExportInvExcel = () => {
    const {mutate} = useMutation({
        mutationFn: (data: InvSearchParamType) => exportInvExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `재고_목록_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
